import { Injectable } from '@angular/core';

import { ServiceBase } from 'app/shared/infrastructure/serviceBase.component'; // leaf import - do not revert to the barrel (app/shared/infrastructure), breaks ng test (circular dependency)
import { HttpClient } from '@angular/common/http';
import { DimensionServiceApiConfiguration } from '../dimension-service-api-configuration';
import { Observable } from 'rxjs-compat/Observable';
@Injectable()
export class DoctorMappingService extends ServiceBase {

    private actionUrl: string;
    private _getBySearch: string;
    private _url: string;
    constructor(private _http: HttpClient, private _configuration: DimensionServiceApiConfiguration) {
        super();
        this.actionUrl = _configuration.serverUrl;
        this._url = this.actionUrl + _configuration.doctorMapping.url;
        this._getBySearch = this.actionUrl + _configuration.doctorMapping.getBySearch;

    }
    getBySearch = (query): Observable<any> => {
        let url = `${this._getBySearch}`;
        url += `?Query=${query.Title ? query.Title : ''}`;
        url += `&StandardCode=${query.StandardCode ? query.StandardCode : ''}`;
        url += `&Status=${query.Status != null ? query.Status ? 1 : 0 : null}`;
        url += `&PageNo=${query.PageNo ? query.PageNo : 1}`;
        url += `&RowNo=${query.RowNo ? query.RowNo : 10}`;
        
        return this._http.get<any>(url);
    }

    post = (data: any): Observable<any> => {
        return this._http.post<any>(this._url, data);
    }

    put = (data: any): Observable<any> => {
        return this._http.put<any>(this._url, data);
    }
}